export default __webpack_public_path__ + "static/media/download-pdf.b91ba98e.svg";